import _ from "lodash";

const getCaseManagerById = (ca, practitioners, practitionerPreferences) => {
  const preference = practitionerPreferences?.filter(
    (preference) => preference.practitionerId === _.get(ca, "practitioner.practitionerId", "")
  )[0];
  const state = _.get(preference, "address.state", null);
  const stateMark = `${state !== null ? `[${state}]` : ""}`;
  if (!_.isEmpty(_.get(ca, "practitioner.firstName", ""))) {
    return `${stateMark}${ca.practitioner.firstName} ${ca.practitioner.lastName}`;
  }
  const practitionerId = _.get(ca, "practitioner.id", null);
  if (_.isEmpty(practitionerId)) {
    return "";
  }
  const practitioner = _.find(practitioners, (p) => p.practitionerId === practitionerId);
  if (_.isEmpty(practitioner)) {
    return "";
  }
  return `${stateMark} ${_.get(practitioner, "firstName", "")} ${_.get(practitioner, "lastName", "")}`;
};
export default getCaseManagerById;
